module.exports = function(bootstrap) {
    bootstrap.run(['Service', function(Service) {
        new Service(
            {
                name: 'visitedEducationalMaterial',
                group: 'rbsmbl',
                cache: false,
                url: '/rbsmbl/x-services/educationMaterial/updateEducationalMaterial',

                fetch: function(userId) {
                    return this.get({ userId: userId });
                }
            }
        );
    }]);
};